import Dropdown from "./Dropdown";
import _ from "lodash";
import { Repository } from "../../types/repository";
import { Paper } from "../../types/Paper";
import addPaperImage from "../../assets/img/add-repo.svg";
import AddPaperToRepositoryModal from "../AddPaperToRepositoryModal/AddPaperToRepositoryModal";
import { ReactComponent as OpenFile } from "../../assets/img/oprn-file.svg";

type NavMenuProps = {
  repositories: { [key: string]: Repository };
  papers: Paper[];
  modalShow: { [key: string]: boolean };
  handleDropdownClick: (repoId: string) => (event: React.MouseEvent) => void;
  addPaperToRepository: (repoId: string, paperName: string) => void;
  toggleModal: (repoId: string) => void;
  hideModal: (repoId: string) => void;
  dropdownVisibility: { [key: string]: boolean };
  paperClickHandler: (
    repoId: string,
    paperId: string
  ) => (event: React.MouseEvent) => Promise<void>;
};

const NavMenu = (props: NavMenuProps) => {
  return (
    <nav className="col-md-3 d-none d-md-block sidebar">
      <div className="sidebar-sticky">
        <div className="navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav" id="RepoList">
            {_.map(props.repositories, (repo, repoId) => (
              <Dropdown
                key={repoId}
                title={repo.name}
                isVisible={!!props.dropdownVisibility[repoId]}
                onClickHandler={(e) => props.handleDropdownClick(repoId)(e)}
                className={!!props.dropdownVisibility[repoId] ? "showf" : ""}
              >
                {props.papers.length > 0 ? (
                  props.papers.map((paper, paperIndex) => (
                    <li key={paperIndex}>
                      <div className="dropdown-item d-flex justify-content-between align-items-center">
                        <a
                          href="/#"
                          onClick={(e) => {
                            props.paperClickHandler(repoId, paper.id)(e);
                          }}
                        >
                          <div className="col-md-10">{paper.name}</div>
                        </a>
                        <div className="col-md-2 text-right">
                          <OpenFile
                            onClick={(event) => {
                              event.preventDefault();
                              if (paper.link && paper.link !== "/#") {
                                window.open(paper.link, "_blank");
                              }
                            }}
                            className="open-file-icon"
                          />
                        </div>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="sub">
                    <p
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      No papers found.
                    </p>
                  </li>
                )}
                <div className="dropdown-item">
                  <li
                    className="btn add-paper"
                    onClick={() => props.toggleModal(repoId)}
                  >
                    <img src={addPaperImage} alt="add paper" /> Add Paper
                  </li>
                  <AddPaperToRepositoryModal
                    show={props.modalShow[repoId] || false}
                    onHide={() => props.hideModal(repoId)}
                    repository_id={repoId}
                    addPaperToRepository={props.addPaperToRepository}
                  />
                </div>
              </Dropdown>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavMenu;
